import styled from 'styled-components';

export const Style = styled.div`
  /* totalDeviceTable */
  .totalDeviceTable {
    overflow-x: hidden;
    margin-bottom: 30px;
    button.show {
      width: 55%;
      margin: 16px 0 10px 0;
      padding: 10px;
      border: 1px solid #ddd;
      background: #f1f1f1;
      outline: none;
      border-radius: 4px;
    }
  }

  .datePicker {
    width: 100%;
    display: flex;
    border: 1px solid #555;
    padding: 5px 16px;
    border-radius: 5px;
    color: #555;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    margin-bottom: 20px;

    input {
      display: none;
    }
  }

  .tableWrap {
    h3 {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      margin-bottom: 16px;
    }
    .dateButtonWrap {
      display: flex;
      margin: 20px 0;
      gap: 12px;

      button {
        width: auto;
        border-radius: 5px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        margin: 0;
      }

      .flexWrap {
        display: flex;
        gap: 8px;
        .calendarWrap {
          width: auto;
          position: relative;
        }
        button {
          padding: 8px 50px;
          border: 1px solid #555;
          background: #fff;
          color: #555;
        }
        button.active {
          border-color: #555;
          background-color: #555;
          color: #fff;
        }
      }
      button.excel {
        padding: 8px 20px;
        background-color: #4dd2ae;
        border-color: #4dd2ae;
        color: #fff;
      }
    }
  }

  .loadingWrap {
    height: 100vh;
    padding-top: 25%;
    text-align: center;
    font-size: 24px;
    line-height: 32px;
    font-weight: 500;
    color: #555;
  }

  table {
    width: 55%;
    margin-bottom: 20px;
    text-align: center;
    background: #fff;
    border: 1px solid #ddd;
    font-size: 14px;

    tr {
      border: 1px solid #000;
    }
  }
  .totalDeviceTable tr th:nth-of-type(3),
  .totalDeviceTable tr th:nth-of-type(6),
  .totalDeviceTable tr th:nth-of-type(8),
  .totalDeviceTable td:nth-child(3),
  .totalDeviceTable td:nth-child(6),
  .totalDeviceTable td:nth-child(8) {
    border-right: thick double #ddd !important;
  }
  td span {
    color: #777;
    font-size: 12px;
  }

  @media (max-width: 1300px) {
    .totalDeviceTable button.show {
      width: 100%;
    }
    table,
    .errorTable {
      width: 100%;
    }

    .tableWrap {
      .dateButtonWrap {
        .flexWrap {
          button {
            padding: 8px 30px;
          }
        }
      }
    }
  }

  .react-datepicker {
    display: flex;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25) !important;
    border-radius: 10px !important;
  }

  /* 헤더 */
  .react-datepicker__header {
    border-radius: 10px 10px 0 0 !important;
  }
  /* 요일 */
  .react-datepicker__day-name {
    width: 28px;
    font-weight: 500;
  }
  /* 일요일 */
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  /* 날짜 */
  .react-datepicker__day {
    width: 28px;
    height: 28px;
    border-radius: 5px;
    font-weight: 400;
  }
  /* 선택불가 */
  .react-datepicker__day--disabled {
    color: #cecece !important;
    pointer-events: none;
  }

  /* 일요일 */
  .react-datepicker__day:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day:nth-child(7) {
    color: #67a4ff;
  }

  /* 현재 */
  .react-datepicker__day--today {
    background: #ffffff;
  }
  /* 헤더 */
  .react-datepicker__header {
    border-radius: 10px 10px 0 0;
  }
  /* 요일 */
  .react-datepicker__day-name {
    width: 28px;
    font-weight: 500;
  }
  /* 일요일 */
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  /* outside */
  .react-datepicker__day--outside-month {
    background: #fff !important;
    border: none;
  }
  .react-datepicker__week {
    display: flex;
    align-items: center;
  }
  /* 선택한 날짜 */
  .react-datepicker__day--selected {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 600;
  }

  /* 월 선택 날짜 */
  .react-datepicker__month-text {
    padding: 6px;
  }
  .react-datepicker__month-text--selected {
    background: #4dd2ae;
    color: #ffffff;
    font-weight: 600;
  }
`;
